import { useQuery } from "@tanstack/react-query";
import { isMock, getJson } from "./client";
import type { ModelContext } from "./types";

const MOCK_MODEL: ModelContext = {
  modelId: 1,
  modelName: "Champion",
  modelVersion: "1.2",
  productType: "PG + Corp",
  modelTier: 1,
  lastRunCohort: "2025-06",
  cohortsMonitored: 17,
};

export async function fetchModelContext(modelId: number = 1): Promise<ModelContext> {
  if (isMock) return Promise.resolve(MOCK_MODEL);
  return getJson<ModelContext>(`model-drift-monitoring/model?model_id=${modelId}`);
}

export function useModelContext(modelId: number = 1) {
  return useQuery({
    queryKey: ["model-context", modelId],
    queryFn: () => fetchModelContext(modelId),
    enabled: modelId > 0,
  });
}

export interface ModelRegistryEntry {
  modelId: number;
  modelName: string;
  modelVersion: string;
  productType: string;
  modelTier: number;
}

export async function fetchModelRegistry(): Promise<ModelRegistryEntry[]> {
  if (isMock) return [{ modelId: MOCK_MODEL.modelId, modelName: MOCK_MODEL.modelName, modelVersion: MOCK_MODEL.modelVersion, productType: MOCK_MODEL.productType, modelTier: MOCK_MODEL.modelTier }];
  return getJson<ModelRegistryEntry[]>("model-drift-monitoring/model-registry");
}

export function useModelRegistry() {
  return useQuery({ queryKey: ["model-registry"], queryFn: fetchModelRegistry });
}
